const defaultConfig = {
  env: process.env.NODE_ENV,
  __DEV__: process.env.NODE_ENV === 'development',
  __PROD__: process.env.NODE_ENV === 'production',
  __STAG__: process.env.NODE_ENV === 'staging',
  __TEST__: process.env.NODE_ENV === 'test',

  __API__: 'https://api.coacherly.com/api', //process.env.API_ENDPOINT,
  __GOOGLE_MAP_KEY__: 'AIzaSyA7nknbLmjX8lP2jNiM7Ny6KGZOjbBvWZ',
  __SOCKET__IP: 'wss://socket.coacherly.com',
  __IMG_URL__: 'https://api.coacherly.com/',
  __STRIPE_CLIENT_ID__: '',
  __STRIPE_CONNECT_ACCOUNT_KEY__: '',
  __AGORA_API_KEY__: '',
};

const envConfig = {
  development: () => ({}),
  production: () => ({}),
};

export default Object.assign(defaultConfig, envConfig[defaultConfig.env]());



// WEBPACK FOOTER //
// ./src/config.js